import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bullet-point",
  "use": "bullet-point-usage",
  "viewBox": "0 0 4 4",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 4\" id=\"bullet-point\"><circle cx=\"2\" cy=\"2\" r=\"2\" fill=\"#000\" fill-opacity=\".3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol